/* REQ-051 · permanent home hero (snippets/pm-home-hero.liquid): rotate the 3 scenes every 5s, dots + pause button.
   No auto-advance under prefers-reduced-motion; pauses on hover/focus and in background tabs.
   Runs only while the hero is visible: a live campaign (html.pm-campaign-live) hides it, and when that campaign ends
   on an open page the class goes away and rotation starts here (MutationObserver). No dependencies. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-pmh-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-pmh-go]'));
    var pz = hero.querySelector('[data-pmh-pause]');
    if (slides.length < 2) return;
    var i = 0, hover = false, stopped = !!(reduce && reduce.matches), timer = null;

    // later scenes load once the page is idle and this hero is visible (never while a campaign hero has the slot)
    var rested = false;
    function loadRest() { if (rested) return; rested = true; slides.forEach(function (s) { var img = s.querySelector('img[loading="lazy"]'); if (img) img.loading = 'eager'; }); }
    function loadRestWhenIdle() { if (document.readyState === 'complete') loadRest(); else window.addEventListener('load', loadRest, { once: true }); }

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        if (on) { s.removeAttribute('aria-hidden'); s.inert = false; s.removeAttribute('inert'); }
        else { s.setAttribute('aria-hidden', 'true'); s.inert = true; s.setAttribute('inert', ''); }
      });
      dots.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    function visible() { return hero.offsetParent !== null; } // CSS decides (a live campaign hero hides this one)
    function step() { if (!hover && !stopped && !document.hidden && visible()) show(i + 1); }
    function run() { if (timer || !visible()) return; loadRestWhenIdle(); timer = setInterval(step, 5000); }
    function halt() { if (timer) { clearInterval(timer); timer = null; } }
    function setStopped(v) {
      stopped = v;
      hero.classList.toggle('is-paused', v);
      if (pz) pz.setAttribute('aria-label', pz.getAttribute(v ? 'data-l-play' : 'data-l-pause'));
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-pmh-go'), 10) || 0); halt(); run(); });
    });
    if (pz) pz.addEventListener('click', function () { setStopped(!stopped); });
    hero.addEventListener('mouseenter', function () { hover = true; });
    hero.addEventListener('mouseleave', function () { hover = false; });
    hero.addEventListener('focusin', function () { hover = true; });
    hero.addEventListener('focusout', function () { hover = false; });
    if (stopped) setStopped(true);

    // a campaign that starts or ends while the page is open switches which hero is visible
    if ('MutationObserver' in window) {
      new MutationObserver(function () { if (visible()) run(); else halt(); })
        .observe(root, { attributes: true, attributeFilter: ['class'] });
    }
    run();
  }

  function start() { document.querySelectorAll('[data-pmh]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  // theme editor: a reloaded section brings a new hero
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-pmh]').forEach(init); });
})();
